export interface EStatement {
	reqEStatement: boolean;
	reqEStatementView: boolean;
}
export const EStatementFactory = function(): EStatement {
	return {
		reqEStatement: true,
		reqEStatementView: true,
	} as EStatement;
};